// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"197":"9a73818b","660":"06f0af36"}[chunkId] + ".js";
};